<!--
 * @Author: guojia 66291979@qq.com
 * @Date: 2024-05-14 15:07:05
 * @LastEditors: guojia 66291979@qq.com
 * @LastEditTime: 2024-08-29 20:03:20
 * @FilePath: /lobby/src/components/GridListGames.vue
 * @Description: 
 * 
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved. 
-->
<template>
  <div>
    <DhGameTitle
      v-if="showTitle"
      :tabItem="{ name: funTab.name, cover: funTab.cover, localName: funTab.localName }"
      :callback="onAllGames"
    />
    <div class="skeleton" v-if="isLoading">
      <div class="min-group" v-for="(item, index) in rowslist" :key="index">
        <div
          class="skeleton-min"
          :style="`background-image: url(${resBaseUrl}placeholder_img.png);`"
        />
        <div
          class="skeleton-min"
          :style="`background-image: url(${resBaseUrl}placeholder_img.png);`"
        />
        <div
          class="skeleton-min"
          :style="`background-image: url(${resBaseUrl}placeholder_img.png);`"
        />
      </div>
    </div>
    <div v-else class="game-content">
      <div class="game" v-if="games.length > 0">
        <div class="game-group" v-for="(row, index) in this.games" :key="index">
          <GameCard
            style="width: 33%"
            v-for="(game, rowIndex) in row"
            :key="rowIndex"
            :game="game"
            :isBig="false"
            height="2.6"
          />
          <!-- <div
            v-for="(game, rowIndex) in row"
            :key="rowIndex"
            class="card-bg"
            :style="game ? `background-image: url(${game.cover})` : ''"
            @click="getGameUrl(game)"
          >
            <div
              :class="`min-card ${game ? getBackgroundColor(game.backColor) : ''}`"
              :style="game ? '' : 'background: rgba(0,0,0,0)'"
            >
              <div v-if="game" class="game-name">
                <div v-for="(item, index) in splitText(game.name, 7)" :key="index">
                  {{ item }}
                </div>
              </div>
            </div>
          </div> -->
        </div>
      </div>
      <div style="height: 0.1rem" />
      <Empty
        v-if="isHome ? games.length == 0 : games.length < 4"
        :showicon="games.length == 0"
        :callback="onReload"
        :hideRecommend="funTab.name == 'Collect' ? false : funTab.name != 'History'"
      />
    </div>
  </div>
</template>
<script>
import { useLobbyStore } from '@/stores/lobby'
import DhGameTitle from '@/components/GameTitle.vue'
import Empty from '@/components/Empty.vue'
import GameCard from '@/components/GameCard.vue'
import { mapActions, mapState } from 'pinia'
import { config } from '@/common/config'
import { chunkArray } from '@/utils/helper'
import { useUserStore } from '@/stores/user'
export default {
  name: 'DhGridListGames',
  components: {
    DhGameTitle,
    Empty,
    GameCard
  },
  props: {
    funTab: {
      type: {},
      default: {}
    },
    showTitle: {
      type: Boolean,
      default: true
    },
    isHome: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isLoading: true,
      games: [],
      resBaseUrl: config.resBaseUrl,
      rowslist: []
    }
  },
  computed: {
    ...mapState(useLobbyStore, ['gameList', 'currentNavTabItem']),
    ...mapState(useUserStore, ['isLogin'])
  },
  mounted() {
    this.rowslist = []
    for (let i = 0; i < this.funTab.rows; i++) {
      this.rowslist.push(i)
    }
    this.onReload(true)
  },

  methods: {
    ...mapActions(useLobbyStore, {
      getGameList: 'getGameList'
    }),
    onAllGames() {
      this.$router.push({ name: 'allgame', params: { categorie: JSON.stringify(this.funTab) } })
    },
    onReload(isfirst = false) {
      if (isfirst || (!this.isLoading && this.funTab.id)) {
        this.isLoading = true
        this.getGameList(this.funTab.id, '', 1, this.isHome ? 3 * this.funTab.rows : 999)
          .then((response) => {
            this.games = chunkArray(response.games, 3, true)
          })
          .catch(() => {
            this.games = []
          })
          .finally(() => {
            this.isLoading = false
          })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.skeleton {
  display: flex;
  width: 100%;
  height: auto;
  justify-content: center;
  flex-direction: column;
  margin-bottom: 0.5rem;
  animation: blink 2s linear infinite;

  .min-group {
    display: flex;
    flex-direction: row;
    width: 100%;
    height: auto;

    .skeleton-min {
      width: 33%;
      height: 2.44rem;
      background-color: #ffffff;
      border-radius: 17px 17px 17px 17px;
      margin-bottom: 5px;
      margin-right: 0.5%;
    }
  }
}

.game-content {
  display: flex;
  width: 100%;
  height: auto;
  justify-content: center;
  flex-direction: column;
  // margin-bottom: 0.5rem;

  .game {
    display: flex;
    flex-direction: column;

    .game-group {
      display: flex;
      flex-direction: row;
      margin-left: -0.05rem;
      width: 100%;
      height: auto;
    }
  }
}

@keyframes blink {
  0%,
  100% {
    opacity: 0.3;
  }

  50% {
    opacity: 0;
  }
}
</style>
